/**
 * Creates and triggers a download for a CSV file from an array of objects.
 * @param headers - An array of strings for the CSV header row.
 * @param rows - An array of arrays, where each inner array represents a row.
 * @param filename - The desired filename for the downloaded file (e.g., "data.csv").
 */
export const downloadCSV = (
  headers: string[],
  rows: (string | number)[][],
  filename: string
) => {
  // Sanitize data to handle commas within fields by wrapping them in quotes
  const processRow = (row: (string | number)[]) =>
    row
      .map(String)
      .map((value) => (value.includes(',') ? `"${value}"` : value))
      .join(',');

  const csvContent = [headers.join(','), ...rows.map(processRow)].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  // Clean up previous object URLs to avoid memory leaks
  if (link.href) {
    URL.revokeObjectURL(link.href);
  }

  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
